import { RouteConfig } from '@abaco/web-common/src/app';

export type BreadCrumb = { text: string; link?: string };

function breadCrumb(params: { [key: string]: string }, isSingleSubject = true): BreadCrumb[] {
    const ret: BreadCrumb[] = [];
    if (!isSingleSubject) {
        ret.push({
            text: "subject-list",
            link: "/"
        });
    }
    ret.push({
        text: "contracts-list",
        link: `/subject/${encodeURIComponent(params.subjectId)}/contracts`
    });

    ret.push({
        text: "project-change-requests",
        link: `/subject/${encodeURIComponent(params.subjectId)}/contracts/${encodeURIComponent(params.contractId)}/application/${encodeURIComponent(params.applicationId)}/change-requests`
    });
    return ret;
}

const children: RouteConfig[] = [
    {
        name: "change-requests-home",
        path: "/",
        component: () => import("./components/ChangeRequests/ChangeRequestsHome.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    {
        name: "change-requests-agreement",
        path: "agreement",
        component: () => import("./components/ChangeRequests/ChangeRequestsAgreement.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    {
        name: "chrq-form-a",
        path: "form-a",
        component: () => import("./components/ChangeRequests/ChangeRequestsFormA.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    {
        name: "chrq-form-b",
        path: "form-b",
        component: () => import("./components/ChangeRequests/ChangeRequestsFormB.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
    {
        name: "chrq-form-b-line-items",
        path: "form-b-line-items",
        component: () => import("./components/ChangeRequests/ChangeRequestsFormBLineItems.vue"),
        redirect: { name: "chrq-form-b-line-items-list" },
        props: true,
        meta: {
            breadCrumb
        },
        children: [
            {
                name: "chrq-form-b-line-items-list",
                path: "list",
                component: () => import("./components/ChangeRequests/ChangeRequestsFormBLineItemsList.vue"),
                props: true,
                meta: {
                    breadCrumb(params: { [key: string]: string }, isSingleSubject?: boolean) {
                        const ret: BreadCrumb[] = breadCrumb(params, isSingleSubject);
                        ret.push({
                            text: "chrq-form-b-line-items-list",
                            link: `/subject/${encodeURIComponent(params.subjectId)}/contracts/${encodeURIComponent(params.contractId)}/change-requests/form-b-line-items`
                        });
                        return ret;

                    }
                },
            },
            {
                name: "chrq-form-b-line-items-edit",
                path: ":itemId/edit",
                component: () => import("./components/ChangeRequests/ChangeRequestsFormBLineItemsEdit.vue"),
                props: true,
                meta: {
                    breadCrumb(params: { [key: string]: string }, isSingleSubject?: boolean) {
                        const ret: BreadCrumb[] = breadCrumb(params, isSingleSubject);

                        ret.push({
                            text: "chrq-form-b-line-items-list",
                            link: `/subject/${encodeURIComponent(params.subjectId)}/contracts/${encodeURIComponent(params.contractId)}/change-requests/form-b-line-items`
                        });

                        ret.push({
                            text: "chrq-form-b-line-items-edit",
                            link: `/subject/${encodeURIComponent(params.subjectId)}/contracts/${encodeURIComponent(params.contractId)}/change-requests/form-b-line-items/${params.itemId}/edit`
                        });

                        return ret;
                    }
                },
            },
            {
                name: "chrq-form-b-line-items-quotation-edit",
                path: ":itemId/quotation/:quotationId/edit",
                component: () => import("./components/ChangeRequests/ChangeRequestsFormBLineItemsQuotationEdit.vue"),
                props: true,
                meta: {
                    breadCrumb(params: { [key: string]: string }, isSingleSubject?: boolean) {
                        const ret: BreadCrumb[] = breadCrumb(params, isSingleSubject);

                        ret.push({
                            text: "chrq-form-b-line-items-list",
                            link: `/subject/${encodeURIComponent(params.subjectId)}/contracts/${encodeURIComponent(params.contractId)}/change-requests/form-b-line-items`
                        });

                        ret.push({
                            text: "chrq-form-b-line-items-edit",
                            link: `/subject/${encodeURIComponent(params.subjectId)}/contracts/${encodeURIComponent(params.contractId)}/change-requests/form-b-line-items/${params.itemId}/edit`
                        });

                        ret.push({
                            text: "chrq-form-b-line-items-quotation-edit",
                            link: `/subject/${encodeURIComponent(params.subjectId)}/contracts/${encodeURIComponent(params.contractId)}/change-requests/form-b-line-items/${params.itemId}/quotation/${params.quotationId}/edit`
                        });

                        return ret;
                    }
                },
            },
        ]
    },
    {
        name: "chrq-form-further-info",
        path: "form-further-info",
        component: () => import("./components/ChangeRequests/ChangeRequestsFormFurtherInfo.vue"),
        props: true,
        meta: {
            breadCrumb
        },
    },
];

const routes: RouteConfig[] = [
    {
        path: "/subject/:subjectId/contracts/:contractId/application/:applicationId/change-requests",
        component: () => import("./components/ChangeRequests/ChangeRequests.vue"),
        props: true,
        meta: {
            breadCrumb
        },
        children
    }
];

export default routes;
